import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useEffect, useState } from 'react'
import NotesFilters from '../NotesFilters'
import styles from '../PersonalAreaController.module.sass'
import NotesRow from '../NotesRow'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import NoData from 'components/general/NoData/NoData'
import { usePersonalAreaContext } from '../PersonalAreaContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

const NotesController = () => {
	const { i18n, addNote } = useGlobal()
	const { selectedTab, notes, isLoading } = usePersonalAreaContext()
	const { notesContentUri, notesContent } = notes

	const [dataCollection, setDataCollection] = useState([])
	const [searchTermQuery, setSearchTermQuery] = useState([])

	const labels = {
		noContentMessage: searchTermQuery
			? i18n`There are no **matches**.`
			: i18n`There are no **notes**.`,
	}

	const handleDataCollectionWithTermSearch = (
		childData,
		childSearchTermQuery
	) => {
		setDataCollection(childData?.matches)
		setSearchTermQuery(childSearchTermQuery?.query)
	}

	useEffect(() => {
		setDataCollection(notesContent)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Widget
				paddings={['small', 'normal', '']}
				applyMaxWidth
				className={styles['filters-widget']}
			>
				<NotesFilters
					handleDataCollection={handleDataCollectionWithTermSearch}
					data={notesContent}
					className={styles['filters-options']}
					selectedTab={selectedTab}
				/>

				<ActionButton
					className={styles['icon-container']}
					onClick={() => {
						addNote &&
							addNote({
								notesContentUri,
							})
					}}
				>
					<Icon name='plus' height='20px' width='20px' />
				</ActionButton>
			</Widget>

			<Widget paddings={['small', 'normal', '']} applyMaxWidth>
				{!isLoading && !dataCollection?.length ? (
					<NoData
						applyMaxWidth
						paddings={['normal', 'normal']}
						message={labels.noContentMessage}
					/>
				) : (
					<>
						{(dataCollection || []).map((item, idx) => (
							<NotesRow
								key={idx}
								noteItem={item}
								contentUri={notesContentUri}
								isNotesTab={true}
							/>
						))}
					</>
				)}
			</Widget>
		</>
	)
}

export default NotesController
